import { useEffect } from 'react';

import { QueryResult, useQuery } from '@apollo/client';
import { captureException } from '@sentry/browser';

import { BasePageDataQuery, PageType } from '../../types/__generated__';
import basePage from '../server/basePage.gql';
import { usePageMeta } from './usePageMeta';

export default function useBasePageQuery(): QueryResult<BasePageDataQuery> {
  const { pageType, pageSlug, isPreview, pageGuid } = usePageMeta();
  const result = useQuery<BasePageDataQuery>(basePage, {
    variables: {
      type: pageType.toUpperCase(),
      slug: pageSlug,
      id: pageGuid,
      preview: isPreview,
      includeEvent: pageType.toUpperCase() === PageType.Fundraising,
    },
    ssr: true,
    errorPolicy: 'all',
  });

  useEffect(() => {
    if (result.error) {
      captureException(result.error);
    }
  }, [result.error]);

  return result;
}
